import { Notify } from 'quasar'

Notify.error = function (msg, title) {
  Notify.create({
    type: 'negative',
    icon: 'las la-exclamation-triangle',
    timeout: 5000,
    position: 'top',
    message: title || 'An Error Occurred',
    caption: msg
  })
}

Notify.info = function (msg, title) {
  Notify.create({
    type: 'info',
    icon: 'las la-check',
    timeout: 5000,
    position: 'top',
    message: title || 'Info',
    caption: msg
  })
}

Notify.ok = function (msg, title) {
  Notify.create({
    type: 'positive',
    icon: 'las la-check',
    timeout: 5000,
    position: 'top',
    message: title || 'Success',
    caption: msg
  })
}

Notify.warning = function (msg, title) {
  Notify.create({
    type: 'warning',
    icon: 'las la-exclamation-triangle',
    timeout: 5000,
    position: 'top',
    message: title || 'Warning',
    caption: msg
  })
}
